import React from 'react'
import LogoIcon from '../images/logo.svg'
import classNames from 'classnames'
import { Link, useLocation } from 'react-router-dom'
import BurgerMenu from './burger-menu'
import ym from 'react-yandex-metrika'
import gtag from '../helpers/gtag'
import {AmplitudeCounter} from "~/amplitude-counter";
import { NewYearHeader } from './new-year-header'

export const Menu: React.FC = () => {
  const [isActive, setActive] = React.useState<boolean>(false)
  const location = useLocation()
  const isPartner = (process.env.IS_BROWSER + '') === 'true' && window.location.pathname === '/partners'

  const getLink = () => {
    switch (process.env.SERVER_NODE_ENV) {
      case 'production':
        if (isPartner) return 'https://partners.onlinepbx.ru'
        return 'https://panel.onlinepbx.ru'
      case 'development':
        if (isPartner) return 'https://partners.test.onlinepbx.ru'
        return 'https://panel.test.onlinepbx.ru'
      case 'stage':
        if (isPartner) return 'https://partners.stage.onlinepbx.ru'
        return 'https://panel.stage.onlinepbx.ru'
    }
  }


  const link = getLink()
  const getUtms = (): any => {
    const utmMedium = document.cookie.replace(/(?:(?:^|.*;\s*)utm_medium\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utmSource = document.cookie.replace(/(?:(?:^|.*;\s*)utm_source\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utmCampaign = document.cookie.replace(/(?:(?:^|.*;\s*)utm_campaign\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utmTerm = document.cookie.replace(/(?:(?:^|.*;\s*)utm_term\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utmContent = document.cookie.replace(/(?:(?:^|.*;\s*)utm_content\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const partnerId = document.cookie.replace(/(?:(?:^|.*;\s*)partnerId\s*=\s*([^;]*).*$)|^.*$/, '$1')
    return {
      utmMedium,
      utmSource,
      utmCampaign,
      utmTerm,
      utmContent,
      partnerId
    }
  }
  const handleActiveScroll = () => {
    setActive(window.scrollY > 0)
  }

  const handleRedirect = () => {
    const utms = getUtms()

    const partnerId = document.cookie.replace(/(?:(?:^|.*;\s*)partnerId\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const promo = document.cookie.replace(/(?:(?:^|.*;\s*)promo\s*=\s*([^;]*).*$)|^.*$/, '$1')

    const query = Object.keys(utms).map(utm => {
      if (!utms[utm]) return
      return `${utm}=${utms[utm]}`
    }).filter(utm => utm).join('&')
    ym('reachGoal', 'lead', { url: window.location.href })
    gtag('event', 'click', { 'event_category': 'lead' })
    AmplitudeCounter('click_registration', { 'name_button': 'Регистрация', 'page_name': 'Шапка сайта' })
    const url = query ? new window.URL(`${link}/register/?${query}`) : new window.URL(`${link}/register`)
    url.searchParams.append('origin', 'https://pbx.uz/')
    !!partnerId && url.searchParams.append('partnerId', partnerId)
    !!promo && url.searchParams.append('promo', promo)

    window.open(url.toString(), '_blank')
  }


  React.useEffect(() => {
    window.addEventListener('scroll', handleActiveScroll)
    return () => {
      window.removeEventListener('scroll', handleActiveScroll)
    }
  })
  return (
    <div className={classNames('onlinepbx__menu__wrapper', {
      'onlinepbx__menu__wrapper__active': isActive
    })}>
      <div className='onlinepbx__container'>
        <div className='onlinepbx__menu'>
          <div className='onlinepbx__menu__left'>
            <Link
              to='/'
              className='onlinepbx__menu__logo'>
              <LogoIcon className='onlinepbx__menu__logo__icon' />
            </Link>
          </div>
          <div>
            <a
                href='tel:+998781132266'
                className='onlinepbx__menu__phone'>
              +998 (78) 113-66-61 Отдел продаж
            </a>
            <a
                href='tel:+998781132650'
                className='onlinepbx__menu__phone'>
              +998 (78) 113-26-50 Техподдержка
            </a>
          </div>
          <div className='onlinepbx__menu__right'>
            <BurgerMenu
                onClick={handleRedirect}
                link={link}/>
            <div className='onlinepbx__menu__right__content'>
              <button
                  onClick={() => window.open(`${link}/login`, '_blank')}
                  className='onlinepbx__menu__button__border'>
                {isPartner ? 'Вход для партнёров' : 'Вход'}
              </button>
              {!isPartner && <button
                onClick={handleRedirect}
                className='onlinepbx__menu__button__fill'>
                Регистрация
              </button>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Menu
